export const WEEKDAYS = [0, 1, 2, 3, 4, 5, 6];
export const SCHEDULE_RULE_KINDS = [
    'daily',
    'weekdays',
    'weekly',
    'monthly',
];
export const DELIVERY_CHANNELS = ['telegram', 'web'];
export const SCHEDULE_RUN_STATUSES = [
    'ok',
    'partial',
    'failed',
    'skipped',
];
export const SCHEDULE_NAME_MAX = 80;
export const SCHEDULE_PROMPT_MAX = 2000;
export const SCHEDULE_RECIPIENTS_MAX = 200;
const DAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const pad = (n) => String(n).padStart(2, '0');
/** "Every weekday at 05:00" — the rule read back in words, for lists and headers. */
export function describeRule(rule) {
    const at = `${pad(rule.hour)}:${pad(rule.minute)}`;
    switch (rule.kind) {
        case 'daily':
            return `Every day at ${at}`;
        case 'weekdays':
            return `Every weekday at ${at}`;
        case 'weekly':
            return `Every ${[...rule.days]
                .sort()
                .map((d) => DAY_NAMES[d])
                .join(', ')} at ${at}`;
        case 'monthly':
            return `Monthly on day ${rule.dayOfMonth} at ${at}`;
    }
}
/** Whether `rule` fires on a local calendar day. `daysInMonth` settles day 29–31. */
export function ruleMatchesDay(rule, day) {
    switch (rule.kind) {
        case 'daily':
            return true;
        case 'weekdays':
            return day.weekday >= 1 && day.weekday <= 5;
        case 'weekly':
            return rule.days.includes(day.weekday);
        case 'monthly':
            return day.dayOfMonth === Math.min(rule.dayOfMonth, day.daysInMonth);
    }
}
//# sourceMappingURL=schedule.js.map